export default __webpack_public_path__ + "static/media/Slide29.c60a7b1f.JPG";